import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Popup } from 'react-leaflet';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix default marker icon paths for webpack/CRA
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const liveIcon = new L.Icon({
  iconUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  className: 'hue-rotate-[220deg]',
});

// Geocoding fallback positions for major cities
const CITY_COORDS = {
  'paris': [48.8566, 2.3522], 'lyon': [45.7640, 4.8357], 'marseille': [43.2965, 5.3698],
  'lille': [50.6292, 3.0573], 'toulouse': [43.6047, 1.4442], 'bordeaux': [44.8378, -0.5792],
  'nice': [43.7102, 7.2620], 'nantes': [47.2184, -1.5536], 'strasbourg': [48.5734, 7.7521],
  'conakry': [9.6412, -13.5784], 'dakar': [14.7167, -17.4677], 'abidjan': [5.3600, -4.0083],
  'cotonou': [6.3654, 2.4183], 'lome': [6.1319, 1.2228], 'libreville': [0.4162, 9.4673],
  'douala': [4.0511, 9.7679], 'yaounde': [3.8480, 11.5021], 'bamako': [12.6392, -8.0029],
  'ouagadougou': [12.3714, -1.5197], 'niamey': [13.5128, 2.1128], 'kinshasa': [-4.4419, 15.2663],
  'brazzaville': [-4.2634, 15.2429], 'algiers': [36.7538, 3.0588], 'casablanca': [33.5731, -7.5898],
  'tunis': [36.8065, 10.1815], 'cairo': [30.0444, 31.2357],
  'london': [51.5074, -0.1278], 'madrid': [40.4168, -3.7038], 'rome': [41.9028, 12.4964],
  'berlin': [52.5200, 13.4050], 'brussels': [50.8503, 4.3517],
  'new york': [40.7128, -74.0060], 'montreal': [45.5017, -73.5673],
};

export const cityToCoords = (city, lat, lng) => {
  if (lat != null && lng != null) return [lat, lng];
  if (!city) return null;
  return CITY_COORDS[city.toLowerCase().trim()] || null;
};

export const MapPanel = ({ departure, arrival, departureLat, departureLng, arrivalLat, arrivalLng, current, height = '400px' }) => {
  const dep = cityToCoords(departure, departureLat, departureLng);
  const arr = cityToCoords(arrival, arrivalLat, arrivalLng);

  // Determine center & bounds
  let center = [46.5, 2.5];
  let zoom = 5;
  if (current) {
    center = current; zoom = 8;
  } else if (dep && arr) {
    center = [(dep[0] + arr[0]) / 2, (dep[1] + arr[1]) / 2];
    zoom = Math.abs(dep[0] - arr[0]) > 20 ? 3 : 4;
  } else if (dep) {
    center = dep; zoom = 6;
  } else if (arr) {
    center = arr; zoom = 6;
  }

  return (
    <div className="rounded-2xl overflow-hidden border bg-card" style={{ height }} data-testid="map-panel">
      <MapContainer center={center} zoom={zoom} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {dep && (
          <Marker position={dep}>
            <Popup>Départ: {departure}</Popup>
          </Marker>
        )}
        {arr && (
          <Marker position={arr}>
            <Popup>Arrivée: {arrival}</Popup>
          </Marker>
        )}
        {dep && arr && (
          <Polyline positions={[dep, arr]} pathOptions={{ color: '#ea580c', weight: 3, opacity: 0.85, dashArray: '8 8' }} />
        )}
        {current && (
          <Marker position={current} icon={liveIcon} data-testid="map-live-marker">
            <Popup>Position actuelle du livreur</Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};
